import styled from "styled-components";
import GlobalStyle from "../../../../GlobalStyle";
import Button from "../../../Common/Components/Button";

const LoginWrapper = styled.div`
  margin: 0px;
  padding: 50px 60px;
  border-radius: 30px;
  background-color: #fff;
  display: block;
  width: 100%;
  .content-wrapper {
    margin-top: 100px;
    margin-bottom: 110px;
  }
  h2 {
    color: #424b50;
    font-size: 54px;
    margin: 64px 0 10px 0;
    font-weight: bold;
    text-align: left;
  }

  p {
    font-size: 16px;
    color: #5e7079;
    font-family: "Roboto", sans-serif;
    margin: 27px 0;
  }
`;

const SignUp = (props) => {
  return (
    <>
      <GlobalStyle />
      <LoginWrapper>
        <div className="content-wrapper">
          <h2>You're all set, {props.first_name} </h2>
          <p>
            Your account has been created and you’re one click away from
            exploring our next generation Account-based marketing platform
            powered by our Smart Content Engine…
          </p>
        </div>
        <Button value="Let's go" />
      </LoginWrapper>
    </>
  );
};

export default SignUp;
